module.exports = __webpack_public_path__ + "static/media/retweetTwitter.294597f6.svg";